import axios from 'axios';

// Create a new axios instance
const api = axios.create({
  baseURL: 'https://api.christmas.termplanner.com.au/api'
});

// This "interceptor" adds the login token to every request, if we have one
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
},
error => {
  return Promise.reject(error);
});

export default api;